import Staff from "./staff/staff_attendance.module";
import Teacher from "./teacher/teacher_attendance.module";

export default {
  modules: {
    Staff,
    Teacher,
  },
};
